class Accordion {
  constructor() {
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach(accordion => {
      const items = accordion.querySelectorAll('.accordion__item');

      items.forEach(item => {
        const head = item.querySelector('.accordion__head');
        head.addEventListener('click', () => this.toggleItem(accordion, item));
      });
    });
  }

  toggleItem(accordion, currentItem) {
    const items = accordion.querySelectorAll('.accordion__item');
    const currentBody = currentItem.querySelector('.accordion__body');

    items.forEach(item => {
      if (item === currentItem) {
        item.classList.toggle('active');

        if (item.classList.contains('active')) {
          item.style.paddingBottom = currentBody.getBoundingClientRect().height + 'px';
        }
        else {
          item.style.paddingBottom = null;
        }
      }
      else {
        item.classList.remove('active');
        item.style.paddingBottom = null;
      }
    });
  }
}

export default Accordion;
